/* Stockeados: barra "te faltan $X para envío gratis" dentro del carrito lateral del tema.
   No modifica archivos del tema: se inserta sola y se vuelve a insertar cada vez que el carrito se actualiza.
   La configuración viene de la sección STK Encabezado (window.STK_SHIP). */
(function () {
  var cfg = window.STK_SHIP;
  if (!cfg || !cfg.threshold) return;
  var last = null, busy = false, timer = null;

  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CL'); }

  function render(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var header = drawer.querySelector('.drawer__header');
    var el = drawer.querySelector('.stk-drawer-ship');
    if (!header || !cart || !cart.item_count) { if (el) el.remove(); return; }

    if (!el) {
      el = document.createElement('div');
      el.className = 'stk stk-drawer-ship';
      el.innerHTML =
        '<p class="stk-drawer-ship__msg" aria-live="polite"></p>' +
        '<div class="stk-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="Progreso hacia envío gratis"><div class="stk-bar__fill"></div></div>';
      header.insertAdjacentElement('afterend', el);
    }

    var left = cfg.threshold - cart.total_price;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total_price * 100) / cfg.threshold)));
    var msg = el.querySelector('.stk-drawer-ship__msg');
    msg.textContent = '';
    if (left > 0) {
      var parts = String(cfg.msgLeft || '').split('[MONTO]');
      msg.appendChild(document.createTextNode(parts[0] || ''));
      if (parts.length > 1) {
        var b = document.createElement('strong');
        b.textContent = money(left);
        msg.appendChild(b);
        msg.appendChild(document.createTextNode(parts.slice(1).join('')));
      }
    } else {
      var d = document.createElement('strong');
      d.textContent = cfg.msgDone || '';
      msg.appendChild(d);
    }
    el.classList.toggle('is-done', left <= 0);
    el.querySelector('.stk-bar__fill').style.width = pct + '%';
    el.querySelector('.stk-bar').setAttribute('aria-valuenow', pct);

    var link = el.querySelector('.stk-drawer-ship__link');
    var url = cfg.url || '/collections/all?sort_by=price-ascending';
    if (left > 0 && cfg.linkLabel) {
      if (!link) {
        link = document.createElement('a');
        link.className = 'stk-drawer-ship__link';
        el.appendChild(link);
      }
      link.href = url;
      link.textContent = cfg.linkLabel;
    } else if (link) {
      link.remove();
    }
  }

  function refresh() {
    if (busy) return;
    busy = true;
    var base = (window.routes && window.routes.cart_url) || '/cart';
    fetch(base + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { last = cart; render(cart); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      if (!drawer.querySelector('.stk-drawer-ship') && last) render(last);
      refresh();
    }, 120);
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    refresh();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && t.closest('.stk-drawer-ship')) continue;
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
